<template>
  <div class="template">

    <div class="container">

      <div class="containerInner">

        <div class="columnLeft">
        </div>

        <div class="columnCenter">

          <h4>Om Digitalt perspektiv</h4>

          <p>
            Digitalt perspektiv är en webbplattform som undersöker digitala ingångar och kontextualiseringar till romaner och andra kulturella verk. Plattformen är en del av ett kommunikationsprojekt som bedrivs vid <a href="https://lir.gu.se/" target="_blank">Institutionen för Litteratur, Idéhistoria och Religion</a> och <a href="https://cdh.hum.gu.se/" target="_blank">Centrum för digital humaniora</a> vid Göteborgs universitet.
          </p>

          <p>
            Design och utveckling av <a href="https://www.tii.se/" target="_blank">RISE Interactive</a>.
          </p>

          <hr />

          <p class="gray">
            <strong>Finansierat av</strong>
            <br />
            <a href="https://www.rj.se/" target="_blank">
              <img src="/static/graphics/rj_small_8cm_450dpi.png" />
            </a>
          </p>

        </div>

        <div class="columnRight">
        </div>

      </div>

    </div>


  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.template{
  border-top: 1px solid lightgray;
  padding: 20px;
  background: #f2f2f2;
}

.center{
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/FooterView.vue